var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-contact-content-field"},[_c('FilterBaseInputText',{attrs:{"prefix":_vm.$t('containsPrefix'),"suffix":_vm.$te('containsSuffix') ? _vm.$t('containsSuffix') : ''},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }